module.exports = "https://static.energy5.com/_next/static/images/cert1-d383c93e2bdedcb74e870754e1b24406.png";